export function localisedEndpoint(countryCode) {
    return function endpoint(name, params = new URLSearchParams()) {
        params.append('countryCode', countryCode);
        return `${name}?${params.toString()}`;
    };
}
